import { mapState } from "vuex";
import * as turf from "@turf/turf";
import * as randomPoint from "random-points-on-polygon";
import PathFinder from "../PathFinder.js";

export default {
	name: "WorkersActions",
	mixins: [PathFinder],
	data() {
		return {
		}
	},
	computed: {
		...mapState([
			"zones",
			"features",
			"stairs_vector",
			"workers",
			"worker_status",
			"debug"
		]),
		pathLayer() { return this.$store.state.map.pathLayer }
	},
    methods: {
        _moveWithinZone(worker) {
            let pattern = this.$config.zone_types[worker.zone.type].movement;
            if (pattern == "stand") return this._standingMovement(worker);
            if (pattern == "grouped") return this._groupedMovement(worker);
            return this._randomMovement(worker);
        },
        _randomMovement(worker) {
			let $sprite = this.sprites[worker.id];
            if ($sprite.moving() || worker.finding_path) return;
            let chance = Math.random();
            if (chance > 0.9905) {
                this._findSpot(worker);
            }
        },
        _standingMovement(worker) {
            if (worker.hasMoved != true) {
                this._findSpot(worker);
                worker.hasMoved = true;
            }
        },
        _groupedMovement(worker) {
            let $sprite = this.sprites[worker.id];
            if ($sprite.moving()) return;
            if (worker.hasMoved == true) return;
            var point = randomPoint(1, this.features[worker.zone.id].inner);
            worker.destination = point[0].geometry.coordinates;
            $sprite.setDestination(
                ol.proj.transform(
                    worker.destination,
                    "EPSG:4326",
                    "EPSG:3857"
                )
            );
            worker.hasMoved = true;
        },
        _findSpot(worker, setup) {
            let $sprite = this.sprites[worker.id];
            if (worker.zone.tool == "Circle") {
                let a = Math.random() * 2 * Math.PI;
                let r = worker.zone.radius * Math.sqrt(Math.random());

                let x = r * Math.cos(a);
                let y = r * Math.sin(a);

                worker.destination = [x + worker.zone.center[0], y + worker.zone.center[1]];
                if (setup) return worker.destination;

                $sprite.setDestination(worker.destination, worker.speed);
			}
			else if (worker.zone.tool == 'MultiLineString') {
				let feature = this.features[worker.zone.id];

				let destination = this.$finder.random(feature.turf.geometry.coordinates);
				destination = turf.lineString(destination);
				let position = this.$number.random(turf.length(destination), 0.01);
				position = turf.along(destination, position);
				position = this.$geo.toOL(position.geometry.coordinates);

				let path = this.$geo.pathFinder(worker.coordinates, position, feature.graph);
				if (path && path.length > 1) {
					$sprite.setPath(path);
					worker.path = path;
				}


			}
			else {
				let point = randomPoint(1, this.features[worker.zone.id].turf);

                worker.destination = point[0].geometry.coordinates;
				if (setup) return worker.destination;

				$sprite.setDestination(this.$geo.toOL(worker.destination), worker.speed);
            }
		},
		_selectTargetZone(worker) {

            let target_zones = this.$finder.all({
					type: worker.target_zone_type
				},
				this.zones
			);

            if (worker.target_zone_type == "end") {
                worker.target_zone_type = "start";
                worker.mode = "end";
                target_zones = this.$finder.all({
                        type: "start"
                    },
                    this.zones
                );
            } else if (worker.target_zone_type == 'break') {
                for (var i in target_zones) {
                    let distance = null;
                    let curdistance;
                    let selected_zone;
                    let ref_distance;
                    for (var i in target_zones) {
                        if (worker.zone.id == target_zones[i].id) continue;
                        ref_distance = ol.proj.transform(worker.coordinates, 'EPSG:3857', 'EPSG:4326');
                        curdistance = turf.distance(ref_distance, this.features[target_zones[i].id].center);
                        if (distance === null || curdistance < distance) {
                            distance = curdistance;
                            selected_zone = target_zones[i]
                        }
                    }
                    if (selected_zone) target_zones = [selected_zone];
                    else target_zones = false;
                }
            }

			for (let i in target_zones) {
				if (target_zones[i].companies && target_zones[i].companies.length) {
					if (!target_zones[i].companies.includes(worker.company.id)) delete target_zones[i];
				}
			}

			let target = this.$finder.random(target_zones);
			if (target == undefined) return null;

			return target;
		},
        _findPath(worker) {

			let target_zone_id = worker.target_zone_id;
			if (worker.override) target_zone_id = worker.override;

			let route = [];
			for (let i in this.workers) {
				if (this.workers[i].driver_id == worker.id && this.workers[i].in_vehicle == false && this.workers[i].zone) {
					if (!route.find(o => o.zone_id == this.workers[i].zone.id)) route.push({'zone_id': this.workers[i].zone.id});
				}
			}

			if (!target_zone_id && route.length == 0) return [];
			if ( worker.status == 'at-zone' && worker.zone.id == target_zone_id) return [];
			//if (worker.destination) return [];




			let target_zone = this.zones[target_zone_id];
			let vehicle = {};
			if (worker.in_vehicle) vehicle = this.vehicles[worker.vehicle_id];


			let path ;
			let origin;
			let return_vehicle = false;

			// should the worker to first return the vehicle?
			if (this.$zone.requiresVehicle(worker.zone.id) && worker.in_vehicle) {
				let target_vehicle = this.vehicles[worker.vehicle_id];
				let closestParking = this.$zone.getClosestParking(target_zone, "*", target_vehicle.type);
				if (closestParking) {
					route.push({'zone_id': closestParking.id, return_vehicle: true});
				}
				return_vehicle = true;

				// put the worker in the queue right away
				if (this.$worker.requiresTransportation(worker, [{zone_id: target_zone_id}])) {
					let target_vehicle = this.$worker.getVehicle(worker.id);
					this.$finder.remove(target_vehicle.queue, worker.id);
					if (vehicle.type != target_vehicle.type) target_vehicle.queue.push(worker.id);
				}
			}
			else if (!worker.in_vehicle && this.$zone.requiresVehicle(target_zone.id)) {
				let target_vehicle = this.$worker.getVehicle(worker.id, target_zone.vehicles);
				let closestParking = this.$zone.getClosestParking(target_zone, "*", target_vehicle.type);
				if (closestParking && (worker.override != closestParking.id) && (worker.zone && closestParking.id != worker.zone.id)) {
					route.push({'zone_id': closestParking.id, vehicle: target_vehicle});
				}
				else route.push({'zone_id': target_zone_id, vehicle: target_vehicle});
			}
			else route.push({'zone_id': target_zone_id});


			if ((worker.driver || (this.$worker.requiresTransportation(worker, route) && vehicle.type != 'transport'))) {

				let target_vehicle = this.$worker.getVehicle(worker.id);
				this.$finder.remove(target_vehicle.queue, worker.id);
				if (vehicle.type != target_vehicle.type) target_vehicle.queue.push(worker.id);

				let closestParking = this.$worker.getClosestParking(worker);
				let target_parking = this.$zone.getClosestParking(target_zone, "*", 'transport');

				if (worker.zone.id != target_parking.id) route[0].vehicle = target_vehicle;
				if (worker.zone.id != closestParking.id) {
					route.unshift({'zone_id': closestParking.id});
				}

			}
			else {
				// console.log(worker.id, 'no need car')
			}

			route = this.$finder.unique(route, 'zone_id');

			route.forEach((item, index) => {
				origin = (route[index - 1] != undefined ) ? route[index - 1].path[route[index - 1].path.length - 1] : worker.coordinates;
				path = this._getPath(worker, origin, item.zone_id);
				item.path = path;
				item.length = path.length ? turf.length(turf.lineString(this.$geo.toTurf(path))) : 0;
			});

			worker.route = route;
			if (this.debug) this.$geo.drawPath(route);

		},
		_findSpotInMultiLineSimple(worker) {
			let feature = this.features[worker.zone.id];
			let segment = feature.graph.getClosestFeatureToCoordinate(worker.coordinates);

			let points = {a: new ol.Feature({ geometry: new ol.geom.Point(segment.getGeometry().getFirstCoordinate()) }), b: new ol.Feature({ geometry: new ol.geom.Point(segment.getGeometry().getLastCoordinate()) })};

			let segments = {a: [], b: []};
			for (let key in segments) {
				feature.graph.forEachFeatureIntersectingExtent(points[key].getGeometry().getExtent(), (f) => {
					segments[key].push(f);
				});
			}

			for (let i in segments) {
				for (let j in segments[i]) {
					if (segments[i][j].id == segment.id) delete segments[i][j];
					else segments[i][j].dir = i;
				}
				if (segments[i].length == 0) delete segments[i];
			}


			segments = this.$finder.random(segments);
			let destination = this.$finder.random(segments);
			if (!destination) return;

			let line = turf.lineString(this.$geo.toTurf(destination.getGeometry().getCoordinates()));
			let position = this.$number.random(turf.length(line), 0.01);
			position = turf.along(line, position);
			position = this.$geo.toOL(position.geometry.coordinates);

			if (destination.id == segment.id) {
				$sprite.setDestination(position);
				return;
			}

			let path = [worker.coordinates];
			path.push(points[destination.dir].getGeometry().getCoordinates());
			path.push(position);

			$sprite.setPath(path);
		},
		_findVehicleRoute(worker) {

			var travel_zones = this.$finder.all({'type': 'travel'}, this.zones);
			var route = {};
			for (let i in travel_zones) {

				let travel_zone = travel_zones[i];

				let paths = {...this.$finder.all({'zone': worker.zone.id, 'target': travel_zone.id}, this.paths), ...this.$finder.all({'target': worker.zone.id, 'zone': travel_zone.id}, this.paths) };

				if (Object.keys(paths).length) {
					paths = this.$finder.order(paths, 'length');
					if (!route[1]) route[1] = {zone: travel_zone, path: paths[0]}
					else if (paths[0].length < route[1].path.length) route[1] = { zone: travel_zone, path: paths[0]};
				}

				paths = {...this.$finder.all({'zone': worker.target_zone.id, 'target': travel_zone.id}, this.paths), ...this.$finder.all({'target': worker.target_zone.id, 'zone': travel_zone.id}, this.paths) };

				if (Object.keys(paths).length) {
					paths = this.$finder.order(paths, 'length');
					if (!route[2]) route[2] = {zone: travel_zone, path: paths[0]}
					else if (paths[0].length < route[2].path.length) route[2] = { zone: travel_zone, path: paths[0]};
				}
			}

			if (!route[1]) return;

			worker.route = Object.values(route);
		},
		_assignVehicle(worker) {

			if (worker.vehicle_id) return;
			if (!worker.target_zone) return;

			let vehicle = {};

			if (worker.zone.type == 'travel' && worker.target_zone.type == 'travel') {

				if (!worker.traveling) return;
				vehicle = this.$finder.first({'company.id': worker.company.id, 'zone.id': worker.zone.id, 'full': false, 'driver_id': [null, worker.id], type: 'transport'}, this.vehicles);

				if (!vehicle.id) {
					worker.waiting_vehicle = true;
					return;
				}
				else {
					worker.waiting_vehicle = false;
				}
				vehicle.workers.push(worker.id);
				worker.vehicle_id = vehicle.id;
				vehicle.driver_id = worker.id;


				if (vehicle.workers.length >= this.vehicle_types[vehicle.type].capacity) vehicle.full = true;

				return;
			}


			if (worker.target_zone && worker.target_zone.type == 'travel') return;
			// does the worker needs to board on a vehicle?
			if ( worker.zone.type != 'travel' || (worker.target_zone.vehicles.length == 0 && worker.target_zone.type != 'travel' )) return;

			if (worker.target_zone && worker.target_zone.vehicles.length > 0) {
				vehicle = this.$finder.first({'company.id': worker.company.id, 'zone.id': worker.zone.id, 'full': false, 'driver_id': [null, worker.id], type: worker.target_zone.vehicles}, this.vehicles, true);
			}

			if (!vehicle.id) {
				worker.waiting_vehicle = true;
				return;
			}
			else {
				worker.waiting_vehicle = false;
			}
			vehicle.workers.push(worker.id);
			worker.vehicle_id = vehicle.id;
			vehicle.driver_id = worker.id;
			if (vehicle.workers.length >= this.vehicle_types[vehicle.type].capacity) vehicle.full = true;

		},
		_unboardWorker(worker) {

			if (!worker.in_vehicle) return;

			let vehicle = this.vehicles[worker.vehicle_id];
			//if (worker.target_zone && worker.target_zone.id == worker.zone.id) {
				if (vehicle.type == 'transport') return; //worker.traveling = false;
				worker.in_vehicle = false;
				worker.vehicle_id = null;
				worker.waiting_vehicle = false;
				vehicle.workers.splice(vehicle.workers.indexOf(worker.id) , 1);
				vehicle.zone = worker.zone;
				vehicle.target_zone = worker.target_zone;
				if (vehicle.workers.length < this.vehicle_types[vehicle.type].capacity) vehicle.full = false;
			//}

		},
    }
};
